module.exports = __webpack_public_path__ + "static/img/bx4.a39c6bbb.png";